<template>
  <div class="container">
    <div class="card">
      <div class="card-body" v-dynamic-content:offer_date_expired></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageError',
  mounted() {
    this.$store.dispatch('putActivity', {
      activity: 'VIEW_IQUOTE_NOT_AVAILABLE',
    })
  },
}
</script>
